/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, ON_CALL_UPLOAD,ON_SUBMIT_TRUE, SET_ERR_COUNT, SET_PROCESS_COUNT, PROFILE_INFO, LOADER_STATUS, SET_ERROR, SET_UPLOAD_MSG,UPLOAD_R2A,SUPPLIER_INFO } from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  submitStatus: false,
  errorVal: 0,
  processVal: 0,
  profileData: '',
  loaderStatus: false,
  setErrorVal: false,
  uploadMsg: '',
  isR2a:false,
  supplierInfo: ''
};

/* eslint-disable default-case, no-param-reassign */
const uploadReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case ON_SUBMIT_TRUE:
        return {
          ...state,
          submitStatus:action.submitStatus
        }
      case SET_ERR_COUNT:
        return {
          ...state,
          errorVal:action.errorVal
        }
      case SET_PROCESS_COUNT:
        return {
          ...state,
          processVal:action.processVal
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_ERROR:
        return {
          ...state,
          setErrorVal:action.setErrorVal
        }
      case SET_UPLOAD_MSG:
        return {
          ...state,
          uploadMsg:action.uploadMsg
        }
      case UPLOAD_R2A:
        return {
          ...state,
          isR2a:action.isR2a
        }      
      case SUPPLIER_INFO:
        return {
          ...state,
          supplierInfo:action.supplierInfo
        }
      default:
        return state;
    }
  };

export default uploadReducer;
